<style>
</style>
<template>
  <admin-layout>
    <template v-slot:breadcrumb>
      <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
        <li class="breadcrumb-item text-sm">
          <a class="opacity-5 text-white" href="javascript:;">Admin</a>
        </li>
        <li class="breadcrumb-item text-sm text-white" aria-current="page">
          Configurações
        </li>
      </ol>
    </template>

    <template v-slot:header>
      <h5 class="font-weight-bolder text-white mt-4 mb-0">Configurações</h5>
    </template>

    <template #content>
      <div class="row">
        <form @submit.prevent="update">
          <div class="col-12">
            <div class="card">
              <div class="card-header pb-0">
                <div class="d-flex align-items-center">
                  <p class="mb-0">Configurações</p>
                </div>
              </div>
              <div class="card-body">
                <p class="text-uppercase text-sm">Vincular Prefeitura</p>
                <div class="row">
                  <div class="col-12 col-md-12">
                    <div class="form-group">
                      <label class="text-sm">Prefeitura</label>
                      <select class="form-control" v-model="form.prefeitura_id">
                        <option value="null">Nenhuma</option>
                        <option
                          v-for="(prefeitura, index) in prefeituras"
                          :value="prefeitura.id"
                          :key="index"
                        >
                          {{ prefeitura.descricao }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <button class="btn btn-primary" @click="update">Salvar</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </template>
  </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";

export default {
  props: ["user", "prefeituras"],
  components: {
    AdminLayout,
  },

  data() {
    return {
      form: this.$inertia.form({
        prefeitura_id: this.user.prefeitura_id,
      }),
    };
  },

  methods: {
    update() {
      this.form.patch(this.route("admin.settings.update", this.form), {
        preserveScroll: true,
        onSuccess: () => {
          /* this.closeModal(); */
          /*  this.form.reset(); */
        },
      });
    },
  },

  mounted() {},
};
</script>

